<template>
  <div>
    <a-modal
      :title="imgArr[currentIndex-1]&&imgArr[currentIndex-1].text"
      :visible="visible"
      width="900px"
      :footer="null"
      :closable="false" class="menuTips"

    >
      <div class="content">
        <img :src="imgArr[currentIndex-1]&&imgArr[currentIndex-1].url">

      </div>
      <div class="footer">
        <a-button type="primary" @click="switchImage">我知道了（{{ !currentIndex ? 1 : currentIndex }}/{{ imgArr.length }}）
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import {commonTipsMenu} from "@/api"
import {traverseDpTree} from "@/utils/util";
import store from "@/store";
export default {
  data() {
    return {
      visible: false,
      imgArr: [],
      img: {
        '4000000': [//彩蝶
          {
            url:require('@/assets/img/sidebarTips/1.png'),
            text:"“产品别名库、档案别名库”菜单位置调整"
          },/*{
            url:require('@/assets/img/sidebarTips/2.png'),
            text:"“待核验、待处理、待入库数据“菜单位置调整"
          },*/{
            url:require('@/assets/img/sidebarTips/3.png'),
            text:"“销售、采购、库存数据查询“菜单位置调整"
          }
        ],
        '3000000': [//行为
          {
            url:require('@/assets/img/sidebarTips/4.png'),
            text:"“审批中心“菜单位置调整"
          },{
            url:require('@/assets/img/sidebarTips/5.png'),
            text:"“拜访活动“菜单位置调整"
          },{
            url:require('@/assets/img/sidebarTips/6.png'),
            text:"“工作报告“菜单位置调整"
          }
        ],
        '1000000': [//辖区
          {
            url:require('@/assets/img/sidebarTips/7.png'),
            text:"“岗位/产品/终端关联、辖区关系匹配“菜单位置调整"
          },{
            url:require('@/assets/img/sidebarTips/8.png'),
            text:"“人员、部门标签配置、备案代表“菜单位置调整"
          }
        ],
        '2000000': [//主数据
          {
            url:require('@/assets/img/sidebarTips/9.png'),
            text:"“档案列表“菜单位置调整"
          },{
            url:require('@/assets/img/sidebarTips/10.png'),
            text:"“产品管理、竞品管理“菜单位置调整"
          },{
            url:require('@/assets/img/sidebarTips/11.png'),
            text:"“科室管理、连锁品牌“菜单位置调整"
          }
        ]

      },
      currentIndex: 0
    }
  },
  watch: {
    $route(e) {
      this.init();
    }
  },
  created() {
  },
  methods: {
    /*
    * 初始化
    * */
    init() {
      //顶部菜单module_int
      let mainSelectedKeys=this.$store.state.mainSelectedKeys[0];
      //判断是否是需要提示的菜单module_int
      if(this.img[mainSelectedKeys]==undefined){
        return;
      }
      let parameter={
        module_int:mainSelectedKeys
      }
      //请求接口判断是否需要提示
      commonTipsMenu(parameter).then((res) => {
        if (0 === res.status) {//"status": 0,//0 需提示 1 不需要提示
          this.visible = true;
          this.imgArr = this.img[mainSelectedKeys]
          this.currentIndex = 0
          this.switchImage()
        }
      })

    },
    /*
    * 点击 我知道了
    * */
    switchImage() {
      if (this.currentIndex == this.imgArr.length) {
        this.closeTips();
        return;
      }

      this.currentIndex++;
    },
    /*
    * 关闭提示
    * */
    closeTips() {
      this.visible = false
    }
  }
}
</script>
<style lang="less">
.menuTips {
  /deep/ .ant-modal-header {
    background: #2A3139 !important;

    .ant-modal-title {
      color: #FFFFFF !important;
    }
  }

  /deep/ .ant-modal-body {
    background: #F8F8F8 !important;
  }

  .content {
    margin-bottom: 16px;
    min-height: 400px;
    img {
      width: 100%;
    }
  }

  .footer {
    display: flex;
    justify-content: center;

    button {
      width: 360px;
      height: 50px;
      background: #1890FF;
      opacity: 1;
      border-radius: 8px;

      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 19px;
      color: #FFFFFF;
      opacity: 1;
    }
  }
}

</style>